
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, LogOut } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from '@/components/ui/button';
import { logAuth } from '@/lib/breadcrumbs';

interface CustomerErrorStateProps {
  error: string;
  onLogout: () => void;
  showLogoutButton?: boolean;
}

const CustomerErrorState: React.FC<CustomerErrorStateProps> = ({ 
  error, 
  onLogout,
  showLogoutButton = true
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted/40 p-6">
      <div className="w-full max-w-md space-y-6">
        <div className="flex justify-center">
          <AlertTriangle className="h-12 w-12 text-destructive" />
        </div>
        
        <h1 className="text-2xl font-bold text-center">Authentication Error</h1>
        
        <Alert variant="destructive" className="border-destructive bg-destructive/10">
          <AlertTitle className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" /> 
            Error
          </AlertTitle>
          <AlertDescription className="mt-2">
            {error}
          </AlertDescription>
        </Alert>
        
        {showLogoutButton ? (
          <Button 
            variant="outline" 
            className="w-full flex items-center justify-center gap-2 mt-4"
            onClick={onLogout}
          >
            <LogOut className="h-4 w-4" />
            <span>Logout</span>
          </Button>
        ) : (
          <Button 
            variant="default" 
            className="w-full flex items-center justify-center gap-2 mt-4"
            onClick={() => navigate('/login')}
          >
            <span>Return to Login</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default CustomerErrorState;
